import script from "./UploadFolderHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadFolderHeader.vue?vue&type=script&setup=true&lang=ts"

import "./UploadFolderHeader.vue?vue&type=style&index=0&id=065f6d28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065f6d28"]])

export default __exports__